// @flow
const EVENT_JS_READY = 'js_ready';
const EVENT_INITIALIZED = 'component_initialized';

export { EVENT_INITIALIZED, EVENT_JS_READY };
